"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
/**
 * Checks the validity of most common email addresses based on the RFC 2822 standard.
 *
 * This regex pattern checks for the following criteria:
 * The email address should start with either a series of characters made up of any combination of letters, numbers, dots, hyphens, or underscores followed by an at symbol @, or a string surrounded by double quotes that contains any printable ASCII character.
 * Next, the domain name should start with either an IP address in square brackets (e.g. [192.168.0.1]) or a series of characters made up of any combination of letters, numbers, dashes, or dots, followed by a dot and the top-level domain (TLD). The TLD must be between 2 and 4 letters long.
 *
 * @param {unknown} input - The input value to validate.
 * @returns {boolean} Whether the input is a valid email address or not.
 *
 * @example
 * const email = 'test@example.com';
 * if (isEmail(email)) {
 *   console.log(`${email} is a valid email address.`);
 * } else {
 *   console.error(`${email} is an invalid email address.`);
 * }
 */
const isEmail = (input) => {
    if (!input || typeof input !== "string")
        return false;
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/.test(input);
};
exports.isEmail = isEmail;
